import { cva } from "class-variance-authority";
const toggleVariants = cva(
  `disabled:cursor-not-allowed
    transition-colors focus-visible:outline-none 
    peer group inline-flex h-8 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent 
    focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background
    data-[state=checked]:bg-green-600 hover:data-[state=checked]:bg-green-700 disabled:data-[state=checked]:bg-slate-100
    data-[state=unchecked]:bg-slate-300 hover:data-[state=unchecked]:bg-slate-400 disabled:data-[state=unchecked]:bg-slate-100`,
  {
    variants: {
      size: {
        md: "h-6 w-10",
        lg: "h-8 w-12 "
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
const thumbVariants = cva(
  `data-[state=unchecked]:translate-x-0
  ltr:data-[state=checked]:translate-x-4 rtl:data-[state=checked]:-translate-x-4
    pointer-events-none min-h-full block rounded-full bg-background ring-0 transition-transform group-disabled:bg-slate-300`,
  {
    variants: {
      size: {
        md: "h-5 w-5",
        lg: "h-7 w-7 "
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
export {
  thumbVariants,
  toggleVariants
};
